import { Shape, StickerShape } from "./shape";

//TODO implement access mode
export  enum AccessMode {
    Collaboration = "Collaboration",
    Tutor = "Tutor",
    Presentation = "Presentation"
}
